type Props = {
  id: string;
  label: string;
  value: string;
  max?: number;
  disabled?: boolean;
  onChange: (value: string) => void;
  /** Plain-language meaning of the number, shown under the input. */
  help: string;
  /** Extra status line, e.g. how many packs use their own value. */
  note?: string | null;
};

/** Labelled percent input with an explanation, for the "Defaults" block. */
export function PercentField({ id, label, value, max, disabled, onChange, help, note }: Props) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-[12px] font-medium text-[var(--co-text)]">
        {label} %
      </label>
      <span className="inline-flex w-32 items-center rounded border border-[var(--co-border)] bg-[var(--co-bg)] pr-2 focus-within:border-[var(--co-brand)]">
        <input
          id={id}
          type="number"
          inputMode="decimal"
          min={0}
          max={max}
          step="0.01"
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          className="w-full bg-transparent px-2 py-1.5 font-mono text-[14px] text-[var(--co-text)] outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        />
        <span className="text-[12px] text-[var(--co-muted)]">%</span>
      </span>
      <p className="text-[11px] leading-snug text-[var(--co-muted)]">{help}</p>
      {note && <p className="text-[11px] font-medium text-amber-700">{note}</p>}
    </div>
  );
}
